module.exports = __webpack_public_path__ + "img/yier_03.41050d00.png";